/**
 * Created by Ram on 10/05/2017.
 */

import React, { Component } from 'react';
import humaniseDuration from 'humanise-duration';
import CompletedInstancesTable from './CompletedInstancesTable';
import CompletedTestInstanceOverview from './CompletedTestInstanceOverview';
import { getEnvironmentShort, getErrorMessage, getMeanRuleDownloads } from '../../../util/helpers';

class CompletedTestInstanceList extends Component {
    checkTestState = testInstance => {
        let logs = false,
            ready = true,
            error = false;
        let devicesState = Object.values(testInstance.devices);

        devicesState.map(deviceState => {
            if (typeof deviceState['batteryReady'] !== 'undefined') {
                if (!deviceState['batteryReady']) {
                    ready = false;
                }
            }

            if (typeof deviceState['hostReady'] !== 'undefined') {
                if (!deviceState['hostReady']) {
                    ready = false;
                }
            }
            if (deviceState['logs']) {
                logs = true;
            }
            if (deviceState['error']) {
                error = true;
            }
        });

        if (error) {
            return 'Error';
        } else if (!ready) {
            return 'Cancelled';
        } else {
            if (logs) {
                return 'Completed';
            } else {
                return 'Finished';
            }
        }
    };

    overviewList = () => {
        let { testInstance, scenarioName, scenarioEnvironment } = this.props.loadData;
        let overviewList = {};

        // Scenario details should be displayed from a Test Instance.
        // For old Test Instances, instead of showing an empty Scenario details, we fetch details from the Scenario table and show it.
        if(testInstance.scenario) {
            scenarioName = testInstance.scenario.name;
            scenarioEnvironment = testInstance.scenario.environment;
        }

        if (testInstance) {
            overviewList.status = this.checkTestState(testInstance);
            overviewList.sdkVersion = testInstance.sdkVersion;
            overviewList.mode = testInstance.mode;
            overviewList.meanRuleDownloads = getMeanRuleDownloads(testInstance);
            overviewList["iOS BG Loc Indicator"] = `${testInstance.enableBackgroundLocationIndicator}`;
            overviewList["Android BG Mode"] = `${testInstance.enableBGMode}`;
        }

        let overviewStartTimeDisplay = <span className="not-specified">Not yet started</span>,
            overviewEndTimeDisplay = <span className="not-specified">Not yet started</span>,
            durationDisplay = '--';

        if (
            testInstance !== '' &&
            typeof testInstance.startTime !== 'undefined' &&
            typeof testInstance.endTime !== 'undefined'
        ) {
            overviewStartTimeDisplay = new Date(testInstance.startTime).toLocaleString();
            overviewEndTimeDisplay = new Date(testInstance.endTime).toLocaleString();
            durationDisplay = humaniseDuration(new Date(testInstance.endTime) - new Date(testInstance.startTime));
        }

        overviewList.scenario = scenarioName;
        overviewList.environment = getEnvironmentShort(scenarioEnvironment);
        overviewList.startTime = overviewStartTimeDisplay;
        overviewList.endTime = overviewEndTimeDisplay;
        overviewList.Duration = durationDisplay;

        // add Device DPH as the last detail
        if(testInstance.scenario) {
            overviewList["Device DPH"] = `${!isNaN(testInstance.scenario.deviceDPH) ? testInstance.scenario.deviceDPH + "%" : "N/A"}`;
        }

        return overviewList;
    };

    renderRows(devices, testInstance) {
       return devices && devices.map(device => {
            let logs = '',
                ready = ''

            /** 
             * Now all the relevant device data is stored inside the Test Instance document.
             * The deviceStatus variable is used for backwards compatability. It can be removed 2 months from 18/11/2019 
             * and use `device` can be used
             * */ 
            
            let deviceStatus

            if (!device.deviceId) { 

                deviceStatus = testInstance.devices.find(testDevice => testDevice.deviceId === device._id) || device
            } else {
                deviceStatus = device
            }

            if (deviceStatus && deviceStatus.logs) {
                logs = Object.keys(deviceStatus.logs).map(logName => {
                    const logsUrl = `/service/testInstance/${testInstance._id}/log/${deviceStatus._id || deviceStatus.deviceId}/${logName}`
                    const cssClass = logName === 'battery' ? 'glyphicon glyphicon-bold' : logName === 'host' ? 'glyphicon glyphicon-header' : 'glyphicon glyphicon-map-marker'
                    return (
                        <div key={logName}>
                            <a href={logsUrl}>
                                <span className={cssClass}/>
                            </a>
                        </div>
                    );
                });
            }

            if (deviceStatus) {
                if (deviceStatus.hasOwnProperty('error')) {
                    ready = getErrorMessage(deviceStatus, testInstance.sdkVersion, device.osVersion);
                } else {
                    if (deviceStatus.hasOwnProperty('hostReady')) {
                        if (deviceStatus.hostReady) {
                            ready = 'Host started ';
                        } else {
                            ready = "Host didn't start ";
                        }
                    }

                    if (deviceStatus.hasOwnProperty('batteryReady')) {
                        if (deviceStatus.batteryReady) {
                            ready = ready + 'Battery started';
                        } else {
                            ready = ready + "Battery didn't start";
                        }
                    }
                }
            }

            return (
                <tr key={device.deviceId || device._id} className={device.trackingDevice ? 'tracking-device-color' : ''}>
                    <td>{device.name}</td>
                    <td>{device.model}</td>
                    <td>{device.os}</td>
                    <td>{device.osVersion}</td>
                    <td>{ready}</td>
                    <td>{logs}</td>
                </tr>
            );
        });
    }

    render() {
        let allDevices, testInstanceListMessage;
        let { testInstances, testInstance, devices, sortAsc, sort, compareSelection = [], savedComparisons = [] } = this.props.loadData;
        let arrowDevices = null;

        let { saveComments, goToStats, goToClone, getSingleTestInstance, updateSortState, deleteTestInstance, toggleCompareSelection, clearCompareSelection, goToCompare, openSavedComparison, deleteSavedComparison } = this.props;

        if (this.props.loadData.sortDevicesAsc) {
            arrowDevices = <span className="glyphicon glyphicon-triangle-top" title="Ascending" />;
        } else {
            arrowDevices = <span className="glyphicon glyphicon-triangle-bottom" title="Descending" />;
        }
        
        // In the latest approach we are storing the device data inside the test instance
        const isNewApproach = testInstance && testInstance.devices.some(device => device.hasOwnProperty('os'))

        if (isNewApproach) {
            allDevices = this.renderRows(testInstance.devices, testInstance)
        } else {
            // TODO: Delete this in a two months from 18/11/2019. Keep only the "isNewApproach" part
            allDevices = this.renderRows(devices, testInstance)
        }

        let pageNumberView;
        if (this.props.loadData.editingPageNumber) {
            pageNumberView = (
                <span>
                    <input
                        type="number"
                        className="pagination-input"
                        value={this.props.loadData.pageNumberTemp}
                        onChange={this.props.editPageNumberState}
                        onKeyPress={this.props.saveEditPageNumber}
                    />
                    <span className="pagination-pages">of {this.props.loadData.totalPages}</span>
                </span>
            );
        } else {
            pageNumberView = (
                <a className="pagination-pages" onClick={this.props.enableEditPageNumber}>
                    {this.props.loadData.currentPageNumber} of {this.props.loadData.totalPages}
                </a>
            );
        }

        let pagination;

        if (!testInstanceListMessage) {
            pagination = (
                <div className="test-instance-pagination text-center">
                    <a
                        className={'pagination-button' + (this.props.loadData.currentPageNumber === 1 ? ' not-clickable' : '')}
                        onClick={this.props.handleFirst}
                    >
                        First
                    </a>
                    <a
                        className={
                            'pagination-button' + (this.props.loadData.currentPageNumber === 1 ? ' not-clickable' : '')
                        }
                        onClick={this.props.handlePrevious}
                    >
                        Previous
                    </a>
                    {pageNumberView}
                    <a
                        className={
                            'pagination-button' +
                            (this.props.loadData.currentPageNumber === this.props.loadData.totalPages
                                ? ' not-clickable'
                                : '')
                        }
                        onClick={this.props.handleNext}
                    >
                        Next
                    </a>
                    <a
                        className={
                            'pagination-button' +
                            (this.props.loadData.currentPageNumber === this.props.loadData.totalPages
                                ? ' not-clickable'
                                : '')
                        }
                        onClick={this.props.handleLast}
                    >
                        Last
                    </a>
                </div>
            );
        }

        return (
            <div>
                <ol className="breadcrumb">
                    <li className="active">Analytics</li>
                </ol>

                <div className="test-instance-pagination-main-div pull-left">
                    <div className="search-analytics-test-instance">
                        <div className="row">
                            <div className="col-sm-6">
                                <span className="block-heading">
                                    <span className="glyphicon glyphicon-asterisk" /> Completed Test Instances
                                </span>
                            </div>
                            <div className="col-sm-5">
                                <input
                                    type="search"
                                    placeholder="Search..."
                                    className="form-control"
                                    onChange={this.props.updateSearchState}
                                    value={this.props.loadData.search}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="compare-toolbar">
                        <span className="compare-toolbar__hint">
                            Tick instances to compare their relevant data side by side.
                        </span>
                        <div className="compare-toolbar__actions">
                            {compareSelection.length > 0 && (
                                <a className="compare-toolbar__clear" onClick={clearCompareSelection}>
                                    Clear ({compareSelection.length})
                                </a>
                            )}
                            <a
                                className={
                                    'pagination-button compare-toolbar__compare' +
                                    (compareSelection.length < 2 ? ' not-clickable' : '')
                                }
                                onClick={compareSelection.length >= 2 ? goToCompare : undefined}
                            >
                                Compare Selected ({compareSelection.length})
                            </a>
                        </div>
                    </div>
                    {savedComparisons.length > 0 && (
                        <div className="saved-comparisons">
                            <span className="saved-comparisons__label">Saved comparisons:</span>
                            <div className="saved-comparisons__list">
                                {savedComparisons.map(comparison => (
                                    <span key={comparison._id} className="saved-comparison">
                                        <a
                                            className="saved-comparison__open"
                                            title={`${(comparison.testInstanceIds || []).length} instances`}
                                            onClick={() => openSavedComparison(comparison)}
                                        >
                                            {comparison.name}
                                        </a>
                                        <a
                                            className="saved-comparison__delete"
                                            title="Delete saved comparison"
                                            onClick={() => deleteSavedComparison(comparison._id)}
                                        >
                                            <span className="glyphicon glyphicon-remove" />
                                        </a>
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                    <div className="analytics-test-instance-list">
                        <div className="table table-striped" id="table-analytics-test-instance-list">
                            <CompletedInstancesTable
                                testInstances={testInstances}
                                isSortAsc={sortAsc}
                                onSort={updateSortState}
                                sortBy={sort}
                                onClick={getSingleTestInstance}
                                selectedInstanceId={testInstance._id}
                                goToStats={goToStats}
                                goToClone={goToClone}
                                compareSelection={compareSelection}
                                onToggleCompareSelection={toggleCompareSelection}
                            />
                        </div>
                    </div>
                    {pagination}
                </div>

                <CompletedTestInstanceOverview
                    name={testInstance.name}
                    comments={testInstance.comments}
                    overviewList={this.overviewList()}
                    updateComments={saveComments}
                    testInstanceId={testInstance._id}
                    deleteTestInstance={deleteTestInstance}
                />

                <div className="test-instance-overview-pagination block pull-right device-list-container">
                    <div className="test-instance-devices-list-pagination">
                        <div className="test-instance-overview-head">Devices ({devices.length})</div>

                        <table className="table table-striped">
                            <thead>
                                <tr key="device-details-head">
                                    <th onClick={this.props.updateDevicesSortState.bind(null, 'name')}>
                                        Device name {this.props.loadData.sortDevices === 'name' ? arrowDevices : ''}
                                    </th>
                                    <th onClick={this.props.updateDevicesSortState.bind(null, 'model')}>
                                        Model {this.props.loadData.sortDevices === 'model' ? arrowDevices : ''}
                                    </th>
                                    <th onClick={() => this.props.updateDevicesSortState('os')}>
                                        OS {this.props.loadData.sortDevices === 'os' ? arrowDevices : ''}
                                    </th>
                                    <th onClick={this.props.updateDevicesSortState.bind(null, 'osVersion')}>
                                        OS version {this.props.loadData.sortDevices === 'osVersion' ? arrowDevices : ''}
                                    </th>
                                    <th>Status</th>
                                    <th>Logs</th>
                                </tr>
                            </thead>
                            <tbody>{allDevices}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        ); //return
    } //render
} //CompletedTestInstanceList

export default CompletedTestInstanceList;
